const defaultState = {}

const contentdisplays = (state = defaultState, action) => {
  switch (action.type) {
    case 'CONTENT_DISPLAYS_ADD':
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

export default contentdisplays



// WEBPACK FOOTER //
// ./src/reducers/contentdisplays.js